import { AnimationBuilder, createAnimation } from '@ionic/angular';

export const desktopTransition: AnimationBuilder = (_baseEl, opts: any) => {
	const entering = createAnimation()
		.addElement(opts.enteringEl)
		.duration(260)
		.easing('cubic-bezier(0.2, 0, 0, 1)')
		.fromTo('opacity', '0', '1')
		.fromTo('transform', 'translateY(10px)', 'translateY(0)');

	const leaving = createAnimation()
		.addElement(opts.leavingEl)
		.duration(200)
		.easing('cubic-bezier(0.4, 0, 1, 1)')
		.fromTo('opacity', '1', '0')
		.fromTo('transform', 'translateY(0)', 'translateY(-4px)');

	return createAnimation().addAnimation([entering, leaving]);
};

export const desktopSlideTransition: AnimationBuilder = (_baseEl, opts: any) => {
	const enteringEl = opts.enteringEl as HTMLElement;
	const leavingEl = opts.leavingEl as HTMLElement | undefined;

	// direzione (Ionic la passa in opts.direction)
	const dir = (opts?.direction ?? 'forward') as 'forward' | 'back';

	// offset orizzontale “web-like” (leggero)
	const enterOffset = dir === 'back' ? '-24px' : '24px';
	const leaveOffset = dir === 'back' ? '12px' : '-12px';

	// riduce al minimo se l’utente preferisce meno animazioni
	const win = enteringEl.ownerDocument.defaultView!;
	const reduce = win.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;

	// ENTERING
	const entering = createAnimation()
		.addElement(enteringEl)
		.duration(reduce ? 120 : 220)
		.easing('cubic-bezier(0.2, 0, 0, 1)')
		.fromTo('opacity', '0', '1')
		.fromTo('transform', `translateX(${enterOffset})`, 'translateX(0)');

	// LEAVING (opzionale, se presente)
	const leaving = leavingEl
		? createAnimation()
			.addElement(leavingEl)
			.duration(reduce ? 100 : 180)
			.easing('cubic-bezier(0.4, 0, 1, 1)')
			.fromTo('opacity', '1', '0')
			.fromTo('transform', 'translateX(0)', `translateX(${leaveOffset})`)
		: undefined;

	const root = createAnimation().addAnimation(entering);
	if (leaving) root.addAnimation(leaving);

	return root;
};

export const noopTransition: AnimationBuilder = (_baseEl, opts: any) => {
	// serve un Animation valido → creiamo un'animazione vuota
	return createAnimation()
		.addElement(opts.enteringEl)
		.duration(0);
};